module.exports = __webpack_public_path__ + "img/10-2.f5b646ad.jpg";